import { yupResolver } from '@hookform/resolvers/yup';
import { Button, Grid } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router';
import { FormProvider, RHFTextField } from 'src/components';
import { Paths } from 'src/config';
import { useEditContentTypeMutation } from 'src/redux/services/ContentTypeServices';
import * as Yup from 'yup';

const CourseEditValidationSchema = Yup.object({
  name: Yup.string().required('نام اجباری می باشد'),
  slug: Yup.string().required('اسلاگ اجباری می باشد'),
}).required();

export const ContentTypeEditForm = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [editContentType, { isLoading }] = useEditContentTypeMutation();
  const methods = useForm({
    defaultValues: { name: state?.name, slug: state?.slug },
    resolver: yupResolver(CourseEditValidationSchema),
  });
  const { handleSubmit } = methods;

  async function onSubmit(values) {
    try {
      const body = {
        _id: state?._id,
        name: values.name,
        slug: values.slug,
      };
      await editContentType(body).unwrap();
      enqueueSnackbar(`نوع محتوا ${values.name} ویرایش شد`, { variant: 'success' });
      navigate(Paths.contentType.list.path);
    } catch (error) {
      console.log('CREATE COURSE LEVEL ERROR', error);
      if (error?.data?.err === `content type with name ${values.slug} exists!`) {
        enqueueSnackbar(`نوع محتوا با اسلاگ ${values.slug} قبلا ایجاد شده است`, { variant: 'warning' });
      } else {
        enqueueSnackbar(`نوع محتوا ${values.name} ویرایش نشد`, { variant: 'error' });
      }
    }
  }

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <RHFTextField name={'name'} label={'نام'} />
        </Grid>
        <Grid item xs={6}>
          <RHFTextField name={'slug'} label={'اسلاگ'} />
        </Grid>
        <Grid item>
          <Button variant="contained" disabled={isLoading} type="submit">
            {Paths.contentType.edit.title}
          </Button>
        </Grid>
      </Grid>
    </FormProvider>
  );
};
